export function emailValidator(email: string): boolean {
  // does the email include a @ and a . ?
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
